/**
 * Ein Zahlenwert, der sich jeden Bildaufbau aendern darf.
 *
 * React neu rendern zu lassen, waere hier der falsche Weg: 60-mal pro Sekunde
 * einen Zustand zu setzen, waehrend der Nutzer scrollt, kostet genau die
 * Rechenzeit, die das fluessige Nachrollen braucht - und ausgerechnet das soll
 * gemessen werden. Stattdessen schreibt eine Animationsschleife direkt in den
 * Textknoten, und zwar nur, wenn sich der dargestellte Text wirklich aendert.
 */

import { useEffect, useRef } from 'react'

interface LiveValueProps {
  /** Liefert den anzuzeigenden Text. Wird pro Bild einmal aufgerufen. */
  get: () => string
  className?: string
}

export function LiveValue({ get, className }: LiveValueProps) {
  const nodeRef = useRef<HTMLSpanElement>(null)
  const getRef = useRef(get)
  getRef.current = get

  useEffect(() => {
    let frame = 0
    let previous: string | null = null

    const tick = (): void => {
      const value = getRef.current()
      if (value !== previous && nodeRef.current) {
        nodeRef.current.textContent = value
        previous = value
      }
      frame = requestAnimationFrame(tick)
    }

    frame = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(frame)
  }, [])

  return <span ref={nodeRef} className={className} />
}
